"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.outletVelocity = exports.fanDriveMotorStaticEfficiency = exports.fanDriveMotorMechanicalEfficiency = exports.current = exports.maximumMotorFrequency = exports.motorFrequency = exports.maximumMotorSpeed = exports.motorSpeed = exports.motorPowerAtSpeed = exports.gridPower = exports.shaftPower = exports.drivePower = exports.fanShaftStaticEfficiency = exports.fanShaftMechanicalEfficiency = exports.systemEffectPressureDrop = exports.velocityPressure = exports.totalPressure = exports.staticPressure = exports.maxFanSpeed = exports.fanSpeed = void 0;
exports.fanSpeed = "fmptfanspeed";
exports.maxFanSpeed = "fmptmaxfanspeed";
exports.staticPressure = "fmptstaticpressure";
exports.totalPressure = "fmpttotalpressure";
exports.velocityPressure = "fmptvelocitypressure";
exports.systemEffectPressureDrop = "fmptsystemeffectpressuredrop";
exports.fanShaftMechanicalEfficiency = "fmpfanshaftmechanicalefficiency";
exports.fanShaftStaticEfficiency = "fmptfanshaftstaticefficiency";
exports.drivePower = "fmptdrivepower";
exports.shaftPower = "fmptshaftpower";
exports.gridPower = "fmptgridpower";
exports.motorPowerAtSpeed = "fmptmotorpoweratspeed";
exports.motorSpeed = "fmptmotorspeed";
exports.maximumMotorSpeed = "fmptmaximummotorspeed";
exports.motorFrequency = "fmptmotorfrequency";
exports.maximumMotorFrequency = "fmptmaximummotorfrequency";
exports.current = "fmptcurrent";
exports.fanDriveMotorMechanicalEfficiency = "fmptfandrivemotormechanicalefficiency";
exports.fanDriveMotorStaticEfficiency = "fmptfandrivemotorstaticefficiency";
exports.outletVelocity = "fmptoutletvelocity";
//# sourceMappingURL=result-names.js.map